import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {DataObjectId, RepeatTemplate, Schedule} from 'yougile-model'
import {BooleanHookState} from '@containers/hooks'
import {RadioButton} from '../common/base/radiobutton'
import {LocationChooser} from '../common/controls/location-chooser'
import {ScheduleChooser} from '../common/controls/schedule-chooser/schedule-chooser'

interface Props {
  repeatTemplate: RepeatTemplate
  update: (newVal: RepeatTemplate) => void
  valid: BooleanHookState
}

export const ScheduleEditor = (props: Props) => {
  const {repeatTemplate, update, valid} = props
  const bem = Util.bemFrom('schedule-editor')

  const upSchedule = (schedule: Schedule) =>
    update({...repeatTemplate, schedule})
  const upLoc = (columnId: DataObjectId) => {
    update({...repeatTemplate, columnId})
  }
  const setSuffix = (titleSuffix: RepeatTemplate['titleSuffix']) => () =>
    update({...repeatTemplate, titleSuffix})

  return (
    <div className={bem()}>
      <ScheduleChooser
        className={bem('chooser')}
        schedule={repeatTemplate.schedule}
        latestRepeatTime={repeatTemplate.latestRepeatTime}
        update={upSchedule}
        valid={valid}
        id={repeatTemplate.id}
      >
        <div className={bem('chooser', 'type')}>
          {Lang.msg.repeat.repeatEvery}:
        </div>
      </ScheduleChooser>

      <LocationChooser
        className={bem('location')}
        location={repeatTemplate.columnId}
        update={upLoc}
        onlyColumns={true}
      />

      <div className={bem('suffix-cnt')}>
        <div className={bem('suffix-label')}>
          {Lang.msg.repeat.suffixTitle}:
        </div>

        <div className={bem('suffix')}>
          <RadioButton
            className={bem('suff-opt')}
            active={repeatTemplate.titleSuffix === 'date'}
            onClick={setSuffix('date')}
            label={Lang.msg.repeat.suffixDate}
          />
          <RadioButton
            className={bem('suff-opt')}
            active={repeatTemplate.titleSuffix === 'order'}
            onClick={setSuffix('order')}
            label={Lang.msg.repeat.suffixOrder}
          />
        </div>
      </div>
    </div>
  )
}
